import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Archive, CheckCircle, Pencil, XCircle } from "lucide-react";
import { Tip } from "@/types";

interface TipOperationsProps {
  tip: Tip;
  onEdit: (tip: Tip) => void;
  onArchive: (id: number) => void;
  onUnarchive: (id: number) => void;
  onApprove: (id: number) => void;
  onClearVotes: (id: number) => void;
}

export function TipOperations({
  tip,
  onEdit,
  onArchive,
  onUnarchive,
  onApprove,
  onClearVotes,
}: TipOperationsProps) {
  const totalVotes = (tip.unsw_votes || 0) + (tip.usyd_votes || 0) + (tip.uoa_votes || 0);

  return (
    <div className="flex gap-2">
      {tip.status === 'draft' && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="outline"
                size="sm"
                onClick={() => onApprove(tip.id)}
                className="text-green-600 hover:text-green-700 hover:bg-green-50"
              >
                <CheckCircle className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Approve tip</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onEdit(tip)}
              className="hover:bg-blue-50"
            >
              <Pencil className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Edit tip</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="sm"
              onClick={() => tip.archived ? onUnarchive(tip.id) : onArchive(tip.id)}
              className={tip.archived ? "text-green-600 hover:text-green-700 hover:bg-green-50" : "text-red-600 hover:text-red-700 hover:bg-red-50"}
            >
              <Archive className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>{tip.archived ? 'Unarchive tip' : 'Archive tip'}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      {totalVotes > 0 && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="outline"
                size="sm"
                onClick={() => onClearVotes(tip.id)}
                className="bg-red-50 text-red-600 hover:bg-red-100 hover:text-red-700"
              >
                <XCircle className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Clear votes</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
}
